import React, { useEffect, useRef, useState } from "react";
import { Map, Polyline, Popup, TileLayer, Marker } from "react-leaflet";
import L, { LatLngBounds } from "leaflet";
import "leaflet/dist/leaflet.css";
import { fetchCarRoute } from "../Services/CarRouteViewer.Service";
import { generateIconHelperData } from "src/components/Map/MapHelpers/MapHelpers";
import { CarCategory, VehicleSpeedEnum } from "src/Models/EnumTypes/VehicleEnumTypes";
import moment from "moment";
import { Slider } from "@material-ui/core"; // Używamy starszej wersji Slidera

const CarRouteViewer = ({ noActiveUser, match }) => {
    const { token } = match.params;
    const [route, setRoute] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const mapRef = useRef(null);

    useEffect(() => {
        const getRoute = async () => {
            if (token) {
                const data = await fetchCarRoute(token);
                if (data) {
                    const sortedPath = [...data.path].sort((a, b) => new Date(a[2]).getTime() - new Date(b[2]).getTime());
                    setRoute({ ...data, path: sortedPath });
                }
            }
        };

        getRoute();
    }, [token]);

    useEffect(() => {
        if (route?.path?.length > 0 && mapRef.current) {
            const bounds = new LatLngBounds(route.path.map(p => [p[0], p[1]]));
            mapRef.current.leafletElement.fitBounds(bounds); // Użycie leafletElement dla starszej wersji
        }
    }, [route]);

    if (route === null) {
        return <div style={{ height: "100vh", width: "100vw", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Ładowanie trasy...</div>;
    }

    if (route === undefined || route?.path?.length === 0) {
        return <div style={{ height: "100vh", width: "100vw", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Nie udało się pobrać trasy. Prosimy o kontakt z pomocą techniczną</div>;
    }

    const iconHelper = generateIconHelperData(CarCategory.PASSENGER_CAR, VehicleSpeedEnum.GREEN);
    const html = `<img style="transform: rotate(0deg)" src="${iconHelper.imageUrl}">`;
    
    const Icon = L.divIcon({
        iconSize: noActiveUser ? [30, 30] : iconHelper.imageSize,
        html,
        className: `vehicle-icon vehicle-icon__${VehicleSpeedEnum.GREEN.toLowerCase()}`
    });

    // Funkcja do sprawdzenia, czy pojazd jest w ruchu, czy na parkingu
    const getRouteStatus = (index) => {
        const speed = route.path[index][3]; // Załóżmy, że prędkość jest w czwartym elemencie
        return speed > 0 ? "Ruch" : "Parking";
    };

    return (
        <div>
            <Map
                center={[51.9194, 19.1451]}
                zoom={6}
                style={{ height: "90vh", width: "100vw" }}
                ref={mapRef} // Użycie ref dla starszej wersji
            >
                {route.path.length > 0 && (
                    <Marker
                        position={{
                            lat: route.path[currentIndex][0],
                            lng: route.path[currentIndex][1]
                        }}
                        icon={Icon}
                    >
                        <Popup autoOpen>
                            <strong>Data i godzina:</strong> {moment(route.path[currentIndex][2]).format("YYYY-MM-DD HH:mm:ss")}
                        </Popup>
                    </Marker>
                )}
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {route?.path?.length > 0 && <Polyline positions={route.path.map(p => [p[0], p[1]])} color="blue" weight={4} />}
            </Map>
            <div style={{ padding: 20, background: "#fff", position: "fixed", bottom: 10, left: "50%", transform: "translateX(-50%)", width: "100%", zIndex: 200}}>
                <Slider
                    value={currentIndex}
                    onChange={(e, newValue) => setCurrentIndex(newValue as number)}
                    step={1}
                    min={0}
                    max={route.path.length - 1}
                    // valueLabelDisplay="auto"
                    // valueLabelFormat={() => {
                    //     const date = moment(route.path[currentIndex][2]).format("YYYY-MM-DD HH:mm:ss");
                    //     const status = getRouteStatus(currentIndex);
                    //     return `${date} (${status})`;
                    // }}
                />
            </div>
        </div>
    );
};

export default CarRouteViewer;



// WEBPACK FOOTER //
// ./src/Modules/CarRouteViewer/Views/CarRouteViewer.tsx